import React, {FC} from 'react';
import styled from 'styled-components';

import {TeammateModel} from '../../../../../../libs/shared/core/src/models/api/teammateModel';
import {TeammateAvatar} from '../../../../../../libs/shared/ui/src/components/avatar/teammateAvatar';

/*
 * Props.
 */

interface ConversationCardTeammateProps {
  teammate?: TeammateModel;
}

/*
 * Styles.
 */

const StyledConvTeammate = styled.div`
  grid-area: teammate;
`;

/*
 * Component.
 */

export const ConversationCardTeammate: FC<ConversationCardTeammateProps> = ({teammate}) => {
  if (!teammate) {
    return null;
  }

  return (
    <StyledConvTeammate>
      <TeammateAvatar teammate={teammate} size={20} />
    </StyledConvTeammate>
  );
};
